import React from 'react';

export default function ArrowTwo({
  direction = 'right',
  width = 26,
  height = 17,
  strokeColor = '#666023'
}) {
  const degrees = direction === 'right' ? 0 : 180;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${degrees}deg)`}}
    >
      <path
        d="M1.485 8.3h22.588"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="m17.055 15.32 7.02-7.02-7.02-7.02"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
